import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './achievements.component.html',
	styleUrls: ['./achievements.component.css']
})

export class AchievementsComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/achievements.component.ts